function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M126.23 80.79h.18a1.5 1.5 0 000-3H88.59a1.5 1.5 0 000 3h.18l-4.91 7.34V194l3.91 8.13h39.46l3.91-8.13V88.13zm-33.85 0h30.24l2.9 4.34h-36zm31.17 23.64v73.31h-32.1v-73.31zm1.79 94.73H89.66l-1-2.13h37.72z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "40 75 140 140"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/can-large.svg";
export { SvgComponent as ReactComponent };